// Month constants
export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const MONTH_SHORT_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

// Gulf of Maine bounds
export const GULF_OF_MAINE_BOUNDS = {
  west: -71.1,
  south: 39.65,
  east: -62.28,
  north: 46.02
};

// Color scheme for LEK probability visualization
export const LEK_COLOR_SCHEME = {
  high: { color: 'rgba(255, 0, 0, 0.8)', range: '0.8-1.0', label: 'Highest Density' },
  medium: { color: 'rgba(255, 165, 0, 0.8)', range: '0.5-0.8', label: 'Moderate Density' },
  // low: { color: 'rgba(255, 255, 0, 0.8)', range: '0.2-0.5', label: 'Low Probability' },
  // very_low: { color: 'rgba(0, 255, 255, 0.8)', range: '0.0-0.2', label: 'Very Low Probability' }
}; 